/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { InfinitySpin } from "react-loader-spinner";

class BookingOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
    };
  }

  componentDidMount() {
    this.fetchData();
    this.fetchRestData();
  }

  fetchData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;

    var end_date = this.end_date;
    var start_date = this.start_date;
    var rest = this.rest;

    axios
      .post(endpoints.getBillScanReport, {
        restro_id,
        start_date,
        end_date,
        rest,
      })
      .then((response) => {
        this.setState({
          items: response.data.data ? response.data.data : [],
          total: response.data.total ? response.data.total : 0,
          totalPages: response.data.total_pages
            ? response.data.total_pages
            : null,
          DataisLoaded: true,
        });
      });
  }

  fetchRestData() {
    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;
    const b = this.state.total;
    const links = this.state.restaurent;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;

    // const b = JSON.stringify(a)
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        name: "NAME",
        selector: (row) => row.full_name,
        cellExport: (row) => row.full_name,
        sortable: true,
      },
      {
        name: "NUMBER",
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        name: "ORDER_ID",
        selector: (row) => row.order_id,
        cellExport: (row) => row.order_id,
        sortable: true,
      },
      {
        name: "AMOUNT",
        selector: (row) => row.amount,
        cellExport: (row) => row.amount,
        sortable: true,
      },
      {
        name: "POINTS",
        selector: (row) => row.point_earn,
        cellExport: (row) => row.point_earn,
        sortable: true,
      },
      {
        name: "STATUS",
        selector: (row) => {
          return row.status == 1
            ? "Credit"
            : row.status == 2
            ? "Debit"
            : row.status == 3
            ? "In Process"
            : "Failed";
        },
        cellExport: (row) => {
          return row.status == 1
            ? "Credit"
            : row.status == 2
            ? "Debit"
            : row.status == 3
            ? "In Process"
            : "Failed";
        },
        sortable: true,
      },
      {
        name: "RESTAURANT",
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        name: "ACTION",
        selector: (row) => (
          <div>
            <Link to={`/dashboard/editbooking/${row.id}`}>
              <EditIcon />
            </Link>
          </div>
        ),
        cellExport: (row) => "",
        sortable: false,
      },
    ];

    const c = [
      {
        full_name: "NAME",
        mobile: "NUMBER",
        order_id: "ORDER_ID",
        amount: "AMOUNT",
        point_earn: "POINTS",
        status: "STATUS",
        name: "RESTAURANT",

        // app:"APP STATUS",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Loyalty Point List</h2>

        <div className="row mt-5">
          <DataTableExtensions {...tableData}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(BookingOrder);
